import { render, staticRenderFns } from "./ProductSpecificationsEdit.vue?vue&type=template&id=480f2e8a"
import script from "./ProductSpecificationsEdit.vue?vue&type=script&lang=js"
export * from "./ProductSpecificationsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports